import { useEffect, useMemo, useState } from 'react';
import { SocketNamespace } from '@trinity/chat';
import type { Socket } from 'socket.io-client';
import { createLogger } from '../utils';
import { useGetSocket } from './useGetSocket';
import { useSetupDefaultSocketListeners } from './useSetupDefaultListeners';

type Key = {
  transcriptId: number;
  tagId: number;
};
export const useTranscriptsSocket = (websocketKey?: Key): Socket => {
  const [socket, setSocket] = useState<Socket>();
  const getSocket = useGetSocket(SocketNamespace.Transcripts);

  const logger = useMemo(() => createLogger({
    namespace: SocketNamespace.Transcripts,
  }), []);

  useEffect(() => {
    if (websocketKey) {
      logger.log(`Setting up socket for transcript: ${websocketKey.transcriptId}`);
      const newSocket = getSocket();
      setSocket(newSocket);

      logger.log(`Subscribing to transcript: ${websocketKey.transcriptId}`);
      newSocket.emit('subscribe', websocketKey.transcriptId);

      return () => {
        logger.log(`Cleaning up socket for transcript: ${websocketKey.transcriptId}`);
        newSocket.emit('unsubscribe', websocketKey.transcriptId);
        newSocket.disconnect();
      };
    }
  }, [getSocket, logger, websocketKey]);

  useSetupDefaultSocketListeners(socket, SocketNamespace.Transcripts);

  return socket;
};